
import './style.scss';

const Footer = () => {
  return (
    <div className="footer-wrapper flex">
      <h1>Copyright © 2023 Yuan</h1>
    </div>
  )
}

export default Footer;